// Error types

export const HttpError = 'HTTP';

// Http status codes

export const Unauthorized = 401;

// Application error class

export class AppError {

    constructor(type, message, details) {
        this.type = type || 'Unknown';
        this.message = message || 'Something went wrong...';
        
        if (details) {
            this.details = details;

            if (details.data && details.data.error) {
                this.error = details.data.error;
            }
        }        

        if (this.type === HttpError && this.error) {
            this.message = this.error;
        }
    }

    isHttpError(errorCode) {
        if (this.type !== HttpError || !this.details) return false;      
        return this.details.status === errorCode;
    }
}